import React from 'react';
import { CirculoStyled, ConteudoCheioStyled, FolhaStyled, TelaCheiaStyled, TelaFolhaStyled, TopoStyled, } from './nps-tela.component.style';
// Telas 1 e 2b: topo na cor da empresa e folha branca por cima.
export var NpsTelaFolha = function (_a) {
    var topo = _a.topo, children = _a.children;
    return (React.createElement(TelaFolhaStyled, null,
        React.createElement(TopoStyled, null,
            React.createElement(CirculoStyled, { "aria-hidden": "true", "$diametro": 340, "$topo": "30px", "$esquerda": "100%" }),
            React.createElement(CirculoStyled, { "aria-hidden": "true", "$diametro": 200, "$topo": "100%", "$esquerda": "0" }),
            topo),
        React.createElement(FolhaStyled, null, children)));
};
// Telas 2a e 3: fundo inteiro na cor da empresa.
export var NpsTelaCheia = function (_a) {
    var alinhamentoTopo = _a.alinhamentoTopo, circuloSuperior = _a.circuloSuperior, circuloInferior = _a.circuloInferior, children = _a.children;
    return (React.createElement(TelaCheiaStyled, null,
        React.createElement(CirculoStyled, { "aria-hidden": "true", "$diametro": circuloSuperior.diametro, "$topo": "40px", "$esquerda": circuloSuperior.esquerda }),
        React.createElement(CirculoStyled, { "aria-hidden": "true", "$diametro": circuloInferior.diametro, "$topo": circuloInferior.topo, "$esquerda": "0" }),
        React.createElement(ConteudoCheioStyled, { "$alinhamentoTopo": alinhamentoTopo }, children)));
};
